// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + "1bb9c143d2027293ba09f8e9509d71bc" + ".css";
};